export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—'

  const isNegative = value < 0
  const absoluteValue = Math.abs(value)

  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(absoluteValue)

  return isNegative ? `(${formatted})` : formatted
}

export function formatNumber(
  value: number | null | undefined,
  decimals: number = 2,
): string {
  if (value === null || value === undefined) return '—'

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value)
}

export function parseNumber(value: string): number | null {
  if (!value || value.trim() === '') return null
  // Handle negative values in parentheses like (1,234.56)
  let cleanValue = value.trim()
  let isNegative = false

  if (cleanValue.startsWith('(') && cleanValue.endsWith(')')) {
    isNegative = true
    cleanValue = cleanValue.slice(1, -1)
  } else if (cleanValue.startsWith('-')) {
    isNegative = true
    cleanValue = cleanValue.slice(1)
  }

  const parsed = parseFloat(cleanValue.replace(/[^0-9.]+/g, ''))
  if (isNaN(parsed)) return null

  return isNegative ? -parsed : parsed
}
